import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Stage from './Stage';

import PromotionStageMosaic from '../components/users/PromotionStageMosaic';

const Participate = (props) => {
	const promotion = props?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	const stage = props?.stage?.Stage ?? false;
	const tz = promotion.timezone;
	const has_started = (moment.tz(stage.start_date, tz).isBefore()) ? true : false;
	const has_ended = (moment.tz(stage.end_date, tz).isAfter()) ? false : true;

	const open = (stage !== false && (!promotion.is_multistage || (has_started && !has_ended))) ? true : false;

	return (
		<Router hashType="noslash">
			<Switch>
				<Route path="/promotions/participate/:promotion_id" exact={true} render={(route) => {
					if(props.stages != undefined && (props.stages.length != 1 || !open)) {
						return (
							<PromotionStageMosaic
								brackets={props.brackets}
								stages={props.stages}
								participations={props.participations}
								promo={promotion}
								locale ={props.locale}
							/>
						)
					}

					return (
						<Stage
							{...props}
						/>
					);
				}} />

				<Route path="/promotions/participate/:promotion_id/:stage_id" exact={false}>
					<Stage
						{...props}
					/>
				</Route>
			</Switch>
		</Router>
	)
};

export default Participate;